import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
@Component({
  selector: 'cs-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss']
})
export class FilterDialogComponent {
  @Input() filterTitle = 'title';
  @Input() hideDialogButtons!: boolean;
  @Input() resetActive = false;
  @Input() showCloseIcon = false;
  @Input() enableFiltering = true;
  @Input() ariaLableText = '';
  @Input() isFALLiteUI = false;
  @Output() applyFilters = new EventEmitter<any>();
  @Output() contentReset = new EventEmitter<any>();
  @Output() selectionReset = new EventEmitter<any>();
  @Output() buttonHover = new EventEmitter<boolean>();
  @Output() showDialogClick = new EventEmitter<any>();
  @Output() clearOtherFilters = new EventEmitter<any>();
  showDialog = false;
  public filterDisplayText$ = '';

  @ViewChild('filterContainer') filterContainer!: ElementRef;

  @HostListener('window:click', ['$event'])
  onClick(event: MouseEvent) {
    if (!this.filterContainer.nativeElement.contains(event.target) && this.showDialog) {
      this.showDialog = false;
      this.clearOtherFilters.emit();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setDialogPosition();
  }

  showDialogClicked() {
    this.showDialog = !this.showDialog;
    this.showDialogClick.emit();
  }

  clearFilterContent(): void {
    this.resetActive = false;
    this.showDialog = false;
    this.contentReset.emit();
    this.buttonHover.emit(false);
  }

  clearFilterSelection(): void {
    this.resetActive = false;
    this.selectionReset.emit();
  }

  filterChange(): void {
    this.applyFilters.emit();
    this.showDialog = false;
  }

  emitHover(hover: boolean): void {
    this.buttonHover.emit(hover);
  }

  getAriaLable(): string {
    return this.ariaLableText && this.ariaLableText != '' ? this.ariaLableText : 'Select ' + this.filterTitle + ' filter';
  }

  setDialogPosition(): void {
    const dialogs = Array.from(document.getElementsByClassName('filter-dialog'));
    dialogs.forEach((element: any) => {
      element.style.left = 'initial';
      element.style.right = 'initial';

      if (element.getBoundingClientRect().right > document.body.clientWidth) {
        element.style.right = 0;
        element.style.left = 'initial';
      } else if (element.getBoundingClientRect().left < 0) {
        element.style.right = 'initial';
      }
    });
  }
}
